import { NgClass } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { IWidgetMenuButton } from "../../../map.settings";

@Component({
    selector: "rask-map-menu-button",
    templateUrl: "./map-menu-button.component.html",
    styleUrls: ["./map-menu-button.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgbTooltip,
        NgClass
    ]
})
export class MapMenuButtonComponent {
    @Input() btn: IWidgetMenuButton;
    @Input() view: any;
    @Input() active: boolean;
    @Input() visible: boolean;

    buttonClasses() {
        const classes = {
            active: this.active,
            disabled: this.btn.disabled
        };
        if (this.btn.customButtonClass) {
            classes[this.btn.customButtonClass] = true;
        }
        return classes;
    }
}
